const UPDATE_EVENT = "remedikeep:pwa-update";

export function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return;

  window.addEventListener("load", async () => {
    try {
      const registration = await navigator.serviceWorker.register("/service-worker.js");

      const announceWaiting = () => {
        if (registration.waiting) {
          window.dispatchEvent(new CustomEvent(UPDATE_EVENT, { detail: registration.waiting }));
        }
      };

      announceWaiting();
      registration.addEventListener("updatefound", () => {
        const worker = registration.installing;
        worker?.addEventListener("statechange", () => {
          if (worker.state === "installed" && navigator.serviceWorker.controller) {
            announceWaiting();
          }
        });
      });

      let refreshing = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
      });
    } catch (error) {
      console.warn("RemediKeep service worker registration failed", error);
    }
  });
}
